import React from 'react';

function GoalTypesInfo( ) {
    
    return(<>
      <div><b>Master:</b> A master goal acts as a collection of the other goal types. </div>
      <div><b>Daily Check:</b> A yes/no click for each day. Useful as a habit tracker.</div>
      <div><b>Daily Quantity Target:</b> Used to periodically log values against a target, e.g. weight.</div>
      <div><b>Daily X in Y At Least:</b> Used to track a minimum quantity within a set period, e.g. exercise for at least 5 hours in 7 days.</div>
      <div><b>Daily X in Y Less Than:</b> Used to track a maximum quantity within a set period, e.g. drink less than 4 units of alcohol in 7 days. </div>
      <div><b>Checklist:</b> A simple checklist. Each item in the checklist has its own target date.</div>
      </>);
}

export default GoalTypesInfo;
